import React from "react";
import {Route} from "react-router-dom";

import DashboardIndex from "./index";

const data = [<Route exact key="DashboardIndex" path="/dashboard/index" element={<DashboardIndex />} />];

export default data;
